module.exports = __webpack_public_path__ + "static/HTH4-eb9607215480342ef881c9b6ed59f843.png";